import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { MESSAGE_TEMPLATES } from '@copilot/common/pages/settings/template/data/constant';
import { MessageTemplateModel } from '@copilot/common/pages/settings/template/data/models';

export default createFetchReducer<MessageTemplateModel>(MESSAGE_TEMPLATES);
